<template>
    <div id="nav" class="h-100 vertical pa-0">
        <div class="align-right user-button">
            <a
                id="revdrop"
                ref="revdrop"
                class="btn user btn-small"
                href="#"
                @click="displayDropdown = !displayDropdown"
            >
                <i class="fa fa-user"></i>
                <span class="ml-3">Account</span>
            </a>
            <div
                v-show="displayDropdown"
                id="dropdown"
                v-closable="{
                    handler: () => (displayDropdown = false),
                    exclude: ['revdrop'],
                }"
            >
                <RouterLink to="/logout">Logout</RouterLink>
            </div>
        </div>
        <ul>
            <li class="home">
                <RouterLink to="/staff/home"><i class="icon icon-giglets"></i></RouterLink>
            </li>
            <template v-if="scopes.includes(Scope.StaffContent)">
                <li class="books">
                    <RouterLink active-class="active" to="/staff/books"
                        ><i class="fa fa-fw fa-book-open"></i><span class="title">Library</span></RouterLink
                    >
                </li>
                <li class="tasks tasksScottish">
                    <RouterLink
                        :class="{ active: route.query.curriculum === '1' && route.query.teacher_tasks !== 'true' }"
                        to="/staff/tasks?curriculum=1"
                    >
                        <i class="fa fa-fw fa-clipboard-question"></i><span class="title">CfE Tasks</span>
                    </RouterLink>
                </li>
                <li class="tasks tasksWelsh">
                    <RouterLink
                        :class="{ active: route.query.curriculum === '3' && route.query.teacher_tasks !== 'true' }"
                        to="/staff/tasks?curriculum=3"
                    >
                        <i class="fa fa-fw fa-clipboard-question"></i><span class="title">LNF Tasks</span>
                    </RouterLink>
                </li>
                <li class="tasks tasksEnglish">
                    <RouterLink
                        :class="{ active: route.query.curriculum === '2' && route.query.teacher_tasks !== 'true' }"
                        to="/staff/tasks?curriculum=2"
                    >
                        <i class="fa fa-fw fa-clipboard-question"></i><span class="title">NC Tasks</span>
                    </RouterLink>
                </li>
                <li class="tasks tasksPLC">
                    <RouterLink
                        :class="{ active: route.query.curriculum === '4' && route.query.teacher_tasks !== 'true' }"
                        to="/staff/tasks?curriculum=4"
                    >
                        <i class="fa fa-fw fa-clipboard-question"></i><span class="title">PLC Tasks</span>
                    </RouterLink>
                </li>
                <li class="teacher_tasks">
                    <RouterLink :class="{ active: route.query.teacher_tasks === 'true' }" to="/staff/teacher-tasks"
                        ><i class="fa fa-fw fa-graduation-cap"></i><span class="title">Teacher Tasks</span></RouterLink
                    >
                </li>
            </template>
            <template v-if="scopes.includes(Scope.StaffUsers)">
                <li class="schools">
                    <RouterLink active-class="active" to="/staff/schools"
                        ><i class="fa fa-fw fa-school"></i><span class="title">Schools</span></RouterLink
                    >
                </li>
                <li class="exports">
                    <RouterLink to="/staff/export"
                        ><i class="fa fa-fw fa-cloud-download"></i><span class="title">Export Data</span></RouterLink
                    >
                </li>
            </template>
            <template v-if="scopes.includes(Scope.StaffContent)">
                <li class="notices">
                    <RouterLink to="/staff/notices"
                        ><i class="fa fa-fw fa-message"></i><span class="title">Notice board</span></RouterLink
                    >
                </li>
                <li class="featured_books">
                    <RouterLink to="/staff/featured-books"
                        ><i class="fa fa-fw fa-book-open"></i><span class="title">Featured books</span></RouterLink
                    >
                </li>
            </template>
        </ul>
    </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { Scope } from '~/shared/scopes';

const displayDropdown = ref(false);
const route = useRoute();
const auth = useAuth();
const { scopes } = storeToRefs(auth);
</script>
<style lang="scss" scoped>
#nav.vertical li a {
    height: 48px;
}
#nav.vertical .home a {
    height: initial;
}
#nav ul {
    list-style: none;
}
#nav .active,
#nav .active > i {
    background: #008fd5;
    color: #fff !important;
}
#header {
    position: initial;
}
</style>
